import './view.scss';
